import { render, staticRenderFns } from "./Expression.vue?vue&type=template&id=5218e974&scoped=true&"
import script from "./Expression.vue?vue&type=script&lang=js&"
export * from "./Expression.vue?vue&type=script&lang=js&"
import style0 from "./Expression.vue?vue&type=style&index=0&id=5218e974&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5218e974",
  null
  
)

export default component.exports